module.exports = __webpack_public_path__ + "img/xcx.ab2bf610.png";